import React, { useState, useEffect, useRef } from "react";
import { func, bool, array, string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import Cookies from "universal-cookie";

import HamburgerIcon from "../../atoms/icons/hamburger";
import NavbarSearch from "../NavbarSearch";
import DesktopLogo from "../../atoms/DesktopLogo";
import MobileLogo from "../../atoms/MobileLogo";
import SearchIcon from "../../atoms/icons/search-icon";
import AuthView from "../../rows/AuthView";
import VerticalMenubar from "../VerticalMenubar";
import Icon from "../../icons";
import { Facebook, Twitter } from "../../atoms/icons/StoryPageIcons";
import Notifications from "../Notifications";

import { setVerticalMenuBar } from "../../helper/actions";
import { useStyleMenubar, useDeviceWidth, logoRenderer } from "../../utils/react-utils";
import { getSectionsDataForHeader, getDomainSectionInfo } from "../../utils/utils";
import { pushEngage } from "../../helper/api";

import "./sectionHeaderTopContent.m.css";

const SectionHeaderTopContent = ({
  isVerticalMenubar,
  setVerticalMenuBar,
  stickyHeader = false,
  domainInfo,
  collection,
  sections,
  domainSlug = "",
  hamburgerMenu,
  navbarMenu,
  pushEngageApiKey,
  pageType,
  publisherAttributes
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [domainSectionObj, setSectionDomainObj] = useState({});
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [dot, setDot] = useState(false);
  const ref = useRef(null);
  const cookies = new Cookies();
  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  const fetchNotifications = () => {
    const offset = 0;
    const limit = 4;

    pushEngage(offset, limit, pushEngageApiKey).then(resp => {
      setNotifications(resp);
      if (cookies.get("notifications") && resp.length > 0) {
        resp[0].notification_id !== cookies.get("notifications") ? setDot(true) : setDot(false);
      } else {
        setNotifications(resp);
        resp.length > 0 && setDot(true);
      }
    });
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(() => {
      fetchNotifications();
    }, 150000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  useEffect(() => {
    setSectionDomainObj(getDomainSectionInfo(domainSlug, sections));
  }, [domainSlug]);

  useDeviceWidth(setIsDesktop);
  useStyleMenubar(isVerticalMenubar);

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);
  const toggleVerticalMenubar = () => setVerticalMenuBar(!isVerticalMenubar);

  const getWidth = () => {
    switch (domainSlug) {
      case "kishoralo":
        return 93;
      case "bondhushava":
        return 132;
      case "biggan-chinta":
        return 165;
      case "bigganchinta":
        return 165;
      default:
        return 230;
    }
  };

  const getHeight = () => {
    switch (domainSlug) {
      case "kishoralo":
        return 46;
      case "bondhushava":
        return 36;
      case "biggan-chinta":
        return 38;
      case "bigganchinta":
        return 38;
      default:
        return 78;
    }
  };

  const sectionsDataForHeader =
    collection && collection.metadata.section
      ? getSectionsDataForHeader(sections, domainSlug, collection.metadata.section, domainSectionObj)
      : null;

  const parentSectionMenuItem =
    navbarMenu && navbarMenu.length > 0
      ? sectionsDataForHeader && (sectionsDataForHeader.parentSection || sectionsDataForHeader.currentSection)
        ? sectionsDataForHeader.parentSection
          ? domainSlug && `https://${domainSlug}.qtstage.io/` === sectionsDataForHeader.parentSectionUrl
            ? navbarMenu.find(item => item.completeUrl === sectionsDataForHeader.currentSectionUrl)
            : navbarMenu.find(item => item.completeUrl === sectionsDataForHeader.parentSectionUrl)
          : navbarMenu.find(item => item.completeUrl === sectionsDataForHeader.currentSectionUrl)
        : null
      : null;

  const sectionMenuDom = () => (
    <nav styleName="navbar">
      <ul styleName="parent-section">
        <li className="section">
          <a href={parentSectionMenuItem.url}>{parentSectionMenuItem.title}</a>
        </li>
      </ul>
      <ul styleName="sub-sections" className="sub-sections">
        {parentSectionMenuItem.children.length > 0 &&
          parentSectionMenuItem.children.slice(0, 12).map((item, index) => (
            <li
              styleName="child-section"
              className={` ${item.title} child-section ${
                sectionsDataForHeader.currentSectionUrl === item.completeUrl ? "current-section" : ""
              }`}
              key={index}
            >
              {item.completeUrl === "/#" ? (
                <span>{item.title}</span>
              ) : (
                <Link href={item.completeUrl}>{item.title}</Link>
              )}
            </li>
          ))}
      </ul>
    </nav>
  );

  const childSectionsDom = () => (
    <nav styleName="navbar">
      <ul styleName="parent-section">
        {sectionsDataForHeader.parentSection ? (
          <li className="section">
            <a href={sectionsDataForHeader.parentSectionUrl}>{sectionsDataForHeader.parentSection}</a>
          </li>
        ) : (
          <li className="section">
            <a href={sectionsDataForHeader.currentSectionUrl}>{sectionsDataForHeader.currentSection}</a>
          </li>
        )}
      </ul>
      {sectionsDataForHeader.childSections.length > 0 && (
        <ul styleName="sub-sections" className="sub-sections">
          {sectionsDataForHeader.childSections.slice(0, 12).map((item, index) => (
            <li
              styleName="child-section"
              className={` ${
                sectionsDataForHeader.currentSectionUrl === item.completeUrl ? "current-section" : ""
              } child-section`}
              key={index}
            >
              <Link href={item["section-url"]}>{item["display-name"]}</Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );

  const toggleNotifications = () => {
    if (!showNotifications) {
      cookies.set("notifications", notifications.length && notifications[0].notification_id);
      setDot(false);
    }

    setShowNotifications(!showNotifications);
  };

  return (
    <div styleName="base">
      <div
        styleName={`wrapper ${domainInfo && domainInfo.className ? domainInfo.className : ""}`}
        className="header-top-content"
      >
        <div>
          <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
            <HamburgerIcon
              onMenuToggle={toggleVerticalMenubar}
              isNavbarOpen={!!isVerticalMenubar}
              isDesktop={isDesktop}
            />
            {domainSlug !== "protichinta" && isDesktop && showSearchIcon && !stickyHeader && (
              <span styleName="search-icon" onClick={toggleSearchIcon}>
                <SearchIcon domainSlug={domainSlug} />
              </span>
            )}
            {domainSlug !== "protichinta" && isDesktop && (
              <span ref={ref}>{!showSearchIcon && !stickyHeader && <NavbarSearch />}</span>
            )}
          </div>
          {isVerticalMenubar && (
            <VerticalMenubar
              isVerticalMenubar={isVerticalMenubar}
              isDesktop={isDesktop}
              domainInfo={domainInfo}
              toggleVerticalMenubar={toggleVerticalMenubar}
              hamburgerMenu={hamburgerMenu}
            />
          )}
        </div>
        <div styleName="logo">
          {logoRenderer(
            isDesktop && (domainSlug === "protichinta" || pageType === "section-page") ? (
              <DesktopLogo width={getWidth()} height={getHeight()} />
            ) : (
              <MobileLogo />
            )
          )}
          {isDesktop &&
            domainSlug === "protichinta" &&
            (collection && sections && navbarMenu && navbarMenu.length > 0 && parentSectionMenuItem
              ? sectionMenuDom()
              : childSectionsDom())}
        </div>
        {!stickyHeader && (
          <div styleName="login-wrapper">
            <div styleName="bell-button">
              {domainSlug === "protichinta" && isDesktop && (
                <span styleName="protichinta-icons">
                  {showSearchIcon && (
                    <span styleName="protichinta-search-icon" onClick={toggleSearchIcon}>
                      <SearchIcon domainSlug={domainSlug} width="18" height="18" />
                    </span>
                  )}
                  <span ref={ref}>{!showSearchIcon && <NavbarSearch />}</span>
                  <Link href="https://www.facebook.com/Protichinta/">
                    <Facebook color1="#fbf6de" color2="#555555" />
                  </Link>
                  <Link href="https://twitter.com/Protichinta">
                    <Twitter color1="#fbf6de" color2="#555555" />
                  </Link>
                </span>
              )}
              <div styleName={`bell-container ${dot ? "new-notifications" : "no-notifications"}`}>
                <span styleName="bell" onClick={() => toggleNotifications()}>
                  {" "}
                  <Icon type="bell" className="bell" />
                </span>
                {showNotifications && <Notifications closeView={toggleNotifications} notifications={notifications} />}
              </div>
              {publisherAttributes.showLogin && <AuthView />}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

SectionHeaderTopContent.propTypes = {
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  hamburgerMenu: array,
  stickyHeader: bool,
  pageType: string,
  domainSlug: string,
  domainInfo: object,
  collection: object,
  sections: array,
  navbarMenu: array,
  pushEngageApiKey: string,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
    pageType: get(state, ["qt", "pageType"], ""),
    collection: get(state, ["qt", "data", "collection"], []),
    sections: get(state, ["qt", "config", "sections"], []),
    domainSlug: get(state, ["qt", "domainSlug"]),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    pushEngageApiKey: get(state, ["qt", "config", "publisher-attributes", "push_engage_api_key"], null)
  };
};

const mapDispatchToProps = dispatch => ({
  setVerticalMenuBar: flag => dispatch(setVerticalMenuBar(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(SectionHeaderTopContent);
